<template>
  <div>
    <v-card style="padding: 20px">
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-card-title>New user</v-card-title>
        <v-card-text>
          <v-text-field
            autofocus
            v-model="userName"
            label="User login"
            :rules="[rules.required]"
          ></v-text-field>
          <v-text-field
            v-model="password"
            label="Password"
            type="password"
            :rules="[rules.required]"
          ></v-text-field>
          <v-text-field
            v-model="confirmPassword"
            label="Confirm password"
            type="password"
            :rules="[rules.required, rules.sameAsPassword]"
          ></v-text-field>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions>
          <div class="row row--end">
            <v-btn
              text
              @click="$emit('cancel')"
            >Cancel
            </v-btn>
            <v-btn
              :disabled="!valid"
              text
              color="primary"
              @click="addUser"
            >Add user
            </v-btn>
          </div>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
export default {
  name:  "AddUserForm",
  props: ["connection"],
  data:  function () {
    return {
      valid:           false,
      userName:        "",
      password:        "",
      confirmPassword: "",
      rules:           {
        required:       value => !!value || 'Required',
        sameAsPassword: value => value == this.password || 'Passwords do not match'
      }
    }
  },
  methods: {
    addUser() {
      this.connection
        .invoke("AddUser", this.userName, this.password)
        .then(response => {
          if (response.resultKind === "Success") {
            this.$emit('users-updated', response.entity);
            this.$emit('ok');
          } else {
            this.$emit('failure', response.reason);
          }
        })
        .catch(response => {
          this.$emit('failure', response);
        });
    },
  }
}
</script>

<style scoped>
</style>
